import { AlertBanner } from '@/shared/ui/components';
import { getMaintenanceMessage } from '../lib/maintenanceMessage';
import { MAINTENANCE_END_TIME, MAINTENANCE_START_TIME } from '../config/maintenance.constants';
import './maintenanceBanner.scss';

interface IProps {
  onClose: () => void;
}

const MaintenanceBanner = ({ onClose }: IProps) => {
  const { text, content } = getMaintenanceMessage(MAINTENANCE_START_TIME, MAINTENANCE_END_TIME);
  return (
    <div className="maintenance-banner-container">
      <AlertBanner
        className="maintenance-banner"
        alertType="warning"
        closable
        onClose={onClose}
        description={content}
        ariaLabel={text}
      />
    </div>
  );
};

export default MaintenanceBanner;
